import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiItem\CreateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/CreateWikiItemController.php
* @route '/api/place/{place}/wiki-items'
*/
const CreateWikiItemController = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiItemController.url(args, options),
    method: 'post',
})

CreateWikiItemController.definition = {
    methods: ["post"],
    url: '/api/place/{place}/wiki-items',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiItem\CreateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/CreateWikiItemController.php
* @route '/api/place/{place}/wiki-items'
*/
CreateWikiItemController.url = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { place: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { place: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        place: typeof args.place === 'object'
        ? args.place.id
        : args.place,
    }

    return CreateWikiItemController.definition.url
            .replace('{place}', parsedArgs.place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiItem\CreateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/CreateWikiItemController.php
* @route '/api/place/{place}/wiki-items'
*/
CreateWikiItemController.post = (args: { place: string | { id: string } } | [place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiItemController.url(args, options),
    method: 'post',
})

export default CreateWikiItemController